// extracted by mini-css-extract-plugin
module.exports = {"plans":"styles_plans__B5O_h","plans__title":"styles_plans__title__UnEwQ","plans__subtitle":"styles_plans__subtitle__GxGgI","plans__list":"styles_plans__list__ubGMz"};